module.exports = __webpack_public_path__ + "images/markers-soft_02f9178c83e02bb868e961f151b7ed50.png";